<script setup>
import { STELLAR_AI_BASE_URL, STELLAR_PLUS_AI_BASE_URL } from '@/common/const';
import { useMenuStore } from '@/store/menu';
import { getClientonly } from '@/utils';
import { computed, ref } from 'vue';
const show = ref(false);
const menuStore = useMenuStore();

const stellarAiSrc = computed(() => `${STELLAR_AI_BASE_URL}&user=${getClientonly()}`);
const stellarPlusAiSrc = computed(() => `${STELLAR_PLUS_AI_BASE_URL}&user=${getClientonly()}`);
</script>
<template>
  <div class="ai-chat-button" @click="show = !show">
    <svg t="1766018671392" class="icon" viewBox="0 0 1137 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6111" width="50" height="50" fill="currentColor">
      <path
        d="M86.755507 0.000569A77.255068 77.255068 0 0 0 9.44355 77.255637v541.013033a77.255068 77.255068 0 0 0 77.311957 77.255068h77.255069v56.604413a59.278189 59.278189 0 0 0 92.216837 49.379528l158.947467-105.983941h289.791839a77.255068 77.255068 0 0 0 77.311958-77.255068v-541.013033A77.255068 77.255068 0 0 0 704.966719 0.000569H86.755507z m911.928383 220.273655c54.044414 0 92.728837 38.627534 92.728837 92.728838v502.328609c0 54.101303-38.684423 92.728837-92.728837 92.728838h-100.465722v69.575072a42.495976 42.495976 0 0 1-23.210654 38.684423c-7.96444 3.868442-15.473769 7.679996-23.153765 7.679996-7.736885 0-15.473769 0-23.210654-7.736885l-162.30391-115.939491H527.245929c-54.101303 0-92.728837-38.627534-92.728837-92.728837V745.813488h285.923397c61.838188 0 115.939491-54.044414 115.939491-115.882602v-409.599773h162.30391zM165.944797 488.789631l100.465722-290.360728c10.296883-27.87554 27.704873-42.495976 52.167082-43.861309 24.462209 0 42.495976 14.620436 54.044414 43.80442L469.333073 488.84652c2.616887 8.305773 3.868442 15.303103 3.868442 20.87821-1.251555 20.821322-12.856882 31.288872-34.759092 31.288872-18.090657 0-30.264872-8.305773-36.750202-25.031098l-13.482659-50.119083H250.879861l-15.416881 50.062195c-6.48533 16.782213-18.659545 25.087986-36.750202 25.087986-21.90221 0-33.507537-11.093327-34.759091-33.39376 0-4.152887 0.682666-9.102217 1.934221-14.620436v-4.152886zM318.577601 238.137325l-46.364419 154.510137h92.728837L318.577601 238.137325z m193.194559 265.102075v-306.63094c1.365333-26.623985 14.222214-40.618644 38.684423-42.040866 24.40532 1.365333 37.262202 15.41688 38.627534 41.983977v306.630941c-1.365333 25.201764-14.222214 37.774201-38.684423 37.774201-24.40532 0-37.262202-12.572437-38.627534-37.774201z"
        p-id="6112"
      ></path>
    </svg>
  </div>
  <div class="ai-chat-content" :class="{ show }">
    <div class="ai-chat-content-wrapper">
      <div class="ai-chat-content-header">
        <div class="ai-chat-content-title">AI助手</div>
        <div class="ai-chat-content-close" @click="show = false">✖</div>
      </div>
      <div class="ai-chat-content-body">
        <iframe v-if="menuStore.projectName === 'stellar-ui'" style="width: 100%; height: 100%" :src="stellarAiSrc" frameborder="0"></iframe>
        <iframe v-else style="width: 100%; height: 100%" :src="stellarPlusAiSrc" frameborder="0"></iframe>
      </div>
    </div>
    <div class="ai-chat-content-mask"></div>
  </div>
</template>
<style lang="scss" scoped>
$width: 800px;
$height: 720px;
.ai-chat-button {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 1998;
  width: 80px;
  height: 80px;
  padding: 15px;
  background-color: #fff;
  color: var(--root-color);
  border-radius: 50%;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  cursor: pointer;
  &:hover {
    background-color: var(--root-color);
    color: #fff;
  }
}
.ai-chat-content {
  .ai-chat-content-wrapper {
    position: fixed;
    z-index: 10000;
    width: 0;
    height: 0;
    right: 80px;
    bottom: 80px;
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow: hidden;
    transition: all 0.3s ease;
    transform: translate(0);
    opacity: 0.5;
    .ai-chat-content-header {
      width: $width;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 44px;
      line-height: 44px;
      border-bottom: 1px solid #eee;
      .ai-chat-content-title {
        font-size: 16px;
        font-weight: 500;
        padding: 10px;
      }
      .ai-chat-content-close {
        cursor: pointer;
        font-size: 16px;
        width: 44px;
        height: 44px;
        text-align: center;
      }
    }
    .ai-chat-content-body {
      width: $width;
      height: calc($height - 44px);
    }
  }
  &.show {
    .ai-chat-content-mask {
      width: 100vw;
      height: 100vh;
      position: fixed;
      left: 0;
      top: 0;
      z-index: 1999;
      background-color: rgba(0, 0, 0, 0.5);
    }
    .ai-chat-content-wrapper {
      width: $width;
      height: $height;
      right: 50%;
      bottom: 50%;
      transform: translate(50%, 50%);
      opacity: 1;
    }
  }
}
</style>
